import { useTranslation } from "react-i18next";
import { ChatContact } from "../../api/models/ConversationModel";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import UserTypeBadge from "../badges/UserTypeBadge";
import { Conversation } from "@twilio/conversations";
import { classNames } from "../../helpers";
import LoadingSpinner from "../LoadingSpinner";

type ChatContactsListProps = {
  contacts: ChatContact[];
  onSelectConversation: (contact: ChatContact) => void;
  selectedConversation?: Conversation | undefined;
  isLoading: boolean;
};

export default function ChatContactsList(props: ChatContactsListProps) {
  const { contacts, onSelectConversation, selectedConversation, isLoading } =
    props;
  const LocalBasePath = "page.chat";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  if (isLoading) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <LoadingSpinner size={30} />
      </div>
    );
  }
  return (
    <div className="w-full">
      {contacts.map((contact: ChatContact) => {
        return (
          <div
            className={classNames(
              "px-2 py-6 flex items-center border-b border-gray-200 cursor-pointer",
              !!selectedConversation &&
                selectedConversation.sid == contact.conversationTwillioId &&
                "bg-blue-100"
            )}
            onClick={() => onSelectConversation(contact)}
            key={`${contact.conversationTwillioId} ${contact.name}`}
          >
            <UserProfilePictureAvatar
              profilePictureUrl={contact.profilePictureUrl}
              className="w-10 h-10 flex-shrink-0"
              alt={contact.name}
            />
            <p className="w-full text-base font-medium text-gray-500 rtl:pr-2 rtl:pl-0.5 ltr:pl-2 ltr:pr-0.5">
              {contact.name}
            </p>
            <div>
              <UserTypeBadge userType={contact.badge.toLowerCase()} />
              {!!contact.unreadCount && (
                <div className="rtl:mr-auto ltr:ml-auto  mt-1 p-1 w-6 h-6 bg-[#0075EA] rounded-full flex justify-center items-center">
                  <p className=" text-white text-[10px]">
                    {contact.unreadCount}
                  </p>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
